import Vue from 'vue'

export default {
  createPurchase (params) {
    return Vue.prototype.$http.post('/purchases', params)
  }
}
